import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  font-size: 12px;
  background: #353e47;
`;

const Text = styled.div`
  color: #fff;
  margin: 0 auto;
  max-width: 1280px;
  padding: 30px 20px;
`;

const Footer = () => (
  <Wrapper>
    <Text>
      {new Date().getFullYear()} © Loadsmart, Inc. All rights reserved.
    </Text>
  </Wrapper>
);

export default Footer;
